import type { CSSProperties } from 'react'

/** All bleed band fills use the outer pasteboard tint so the in-trim band matches the trim-outer band. */
export const BLEED_TINT_FILL: CSSProperties = {
  backgroundColor: 'var(--doc-bleed-tint-outside-trim)',
}
